import { trackEvent } from 'shared/helpers/Analytics';

type VehiclesAnalyticsEvent =
  | { name: 'Carrier Viewed Vehicles Page' }
  | {
      name: 'Carrier Clicked Build Load';
      selected_count: number;
      bundle_mode: 'bundle' | 'separate';
      bundlable_count: number;
    }
  | { name: 'Carrier Clicked Filter Bundlable Vehicles' }
  | {
      name: 'Carrier Built Loads From Vehicles';
      selected_count: number;
      bundle_mode: 'bundle' | 'separate';
      loads_created_count: number;
    }
  | { name: 'Carrier Clicked Vehicle Setup' }
  | { name: 'Carrier Completed Vehicle Setup Step 1' }
  | { name: 'Carrier Completed Vehicle Setup Step 2' }
  | {
      name: 'CTMS: Marked as Paid';
      page: 'subhaul-list';
      utm_medium?: string;
    };

export function trackVehiclesEvent(event: VehiclesAnalyticsEvent) {
  const { name, ...props } = event;

  trackEvent(name, props as Record<string, unknown>);
}
